import { Link } from "react-router-dom";
import Navbar from "@/pages/home/components/Navbar";
import Footer from "@/pages/home/components/Footer";
import { allArticles } from "@/mocks/articles";
import { categories } from "@/mocks/categories";

export default function SitemapPage() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />

      <main className="pt-20 md:pt-24 pb-12 md:pb-16">
        <div className="w-full px-4 md:px-8 lg:px-12">
          <div className="max-w-3xl mx-auto">
            <h1 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-2">
              Sitemap
            </h1>
            <p className="text-sm text-foreground-600 mb-8">
              Vollständige Übersicht aller Seiten auf oopbuyspread.beer
            </p>

            {/* Main Pages */}
            <section className="mb-8">
              <h2 className="font-heading text-lg font-semibold text-foreground-900 mb-4 pb-2 border-b border-background-200">
                Hauptseiten
              </h2>
              <ul className="space-y-2">
                <li>
                  <Link to="/" className="text-sm text-primary-600 hover:text-primary-700 transition-colors flex items-center gap-2">
                    <span className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-home-line"></i>
                    </span>
                    Startseite — OOPBUY Spreadsheet Deutschland
                  </Link>
                </li>
                <li>
                  <Link to="/sitemap" className="text-sm text-primary-600 hover:text-primary-700 transition-colors flex items-center gap-2">
                    <span className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-map-pin-line"></i>
                    </span>
                    Sitemap — Alle Seiten im Überblick
                  </Link>
                </li>
              </ul>
            </section>

            {/* Guides */}
            <section className="mb-8">
              <h2 className="font-heading text-lg font-semibold text-foreground-900 mb-4 pb-2 border-b border-background-200">
                SEO Guides & Artikel ({allArticles.length})
              </h2>
              <ul className="space-y-3">
                {allArticles.map((article) => (
                  <li key={article.slug}>
                    <Link
                      to={`/guide/${article.slug}`}
                      className="flex flex-col gap-1 p-3 bg-background-100 rounded-lg border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/30 transition-all"
                    >
                      <span className="text-sm font-medium text-primary-600">{article.title}</span>
                      <span className="text-xs text-foreground-500">{article.subtitle}</span>
                      <span className="text-xs text-foreground-400">{article.readTime} &middot; {article.category}</span>
                    </Link>
                  </li>
                ))}
              </ul>
            </section>

            {/* Categories */}
            <section className="mb-8">
              <h2 className="font-heading text-lg font-semibold text-foreground-900 mb-4 pb-2 border-b border-background-200">
                Produktkategorien auf kaspreadsheet.com
              </h2>
              <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
                {categories.map((cat) => (
                  <a
                    key={cat.name}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors p-2 bg-background-100 rounded-lg flex items-center gap-2"
                  >
                    <span className="w-4 h-4 flex items-center justify-center text-primary-500">
                      <i className={cat.icon}></i>
                    </span>
                    {cat.name}
                  </a>
                ))}
              </div>
            </section>

            {/* External Links */}
            <section>
              <h2 className="font-heading text-lg font-semibold text-foreground-900 mb-4 pb-2 border-b border-background-200">
                Externe Links
              </h2>
              <ul className="space-y-2">
                <li>
                  <a
                    href="https://kaspreadsheet.com"
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors flex items-center gap-2"
                  >
                    <span className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-external-link-line"></i>
                    </span>
                    kaspreadsheet.com — Hauptwebsite
                  </a>
                </li>
              </ul>
            </section>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}